import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useEffect, useState } from 'react';
import { Input as ChakraInput, InputGroup, InputLeftElement, InputRightAddon } from '@chakra-ui/react';
const InputFC = ({ isOnChangeOnlyOnBlur, value, size, disabled, leftElement, rightElement, onChange, onBlur, ...rest }) => {
    const [inputValue, setInputValue] = useState('');
    useEffect(() => {
        setInputValue(value?.toString() ?? '');
    }, [value]);
    return (_jsxs(InputGroup, { size: size, children: [!!leftElement && _jsx(InputLeftElement, { children: leftElement }), _jsx(ChakraInput, { ...rest, value: inputValue, disabled: disabled, onChange: (event) => {
                    setInputValue(event.target.value);
                    if (!isOnChangeOnlyOnBlur) {
                        onChange?.(event.target.value);
                    }
                }, onBlur: (event) => {
                    if (isOnChangeOnlyOnBlur && event.target.value !== value) {
                        onChange?.(event.target.value);
                    }
                    onBlur?.(event.target.value);
                } }), !!rightElement && (_jsx(InputRightAddon, { color: "lightGray", justifyContent: "flex-end", bg: disabled ? 'disabledGray' : 'white', children: rightElement }))] }));
};
export const Input = memo(InputFC);
//# sourceMappingURL=Input.js.map